import { Button } from "@mui/material";
import { FC, ReactNode } from "react";
import { EPI_COLORS } from "./epiColors";
import './EpiWizardActions.scss';

interface Props {
	leftLabel?: string;
	leftIcon?: ReactNode;
	onLeft?: () => void;
	draftLabel?: string;
	onDraft?: () => void;
	primaryLabel: string;
	primaryIcon?: ReactNode;
	primaryDisabled?: boolean;
	onPrimary: () => void;
	hint?: string;
}

const EpiWizardActions: FC<Props> = ({ leftLabel, leftIcon, onLeft, draftLabel, onDraft,
		primaryLabel, primaryIcon, primaryDisabled, onPrimary, hint }) => (
	<div className="epi-wizard-actions">
		<div className="esquerda">
			{!!leftLabel && (
				<Button variant="outlined" startIcon={leftIcon} onClick={onLeft}>
					{leftLabel}
				</Button>
			)}
		</div>
		<div className="direita">
			{!!hint && <span className="dica">{hint}</span>}
			{!!draftLabel && (
				<Button variant="outlined" onClick={onDraft}>
					{draftLabel}
				</Button>
			)}
			<Button
				variant="contained"
				endIcon={primaryIcon}
				disabled={primaryDisabled}
				style={primaryDisabled ? undefined : { backgroundColor: EPI_COLORS.success }}
				onClick={onPrimary}
			>
				{primaryLabel}
			</Button>
		</div>
	</div>
);

export default EpiWizardActions;
